export const getError = state => state.addParameter.get('error')
export const getIsSubmitting = state => state.addParameter.get('isSubmitting')
export const getIsAddingEmail = state => state.addParameter.get('isAddingEmail')
